"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _PopperUnstyled.default;
  }
});

var _PopperUnstyled = _interopRequireDefault(require("./PopperUnstyled"));